import { create } from 'zustand'

import { IOfficeStore, IOfficeStoreProps } from './types'

const INITIAL_STORE: IOfficeStoreProps = {}

export const useOfficeStore = create<IOfficeStore>(set => ({
  ...INITIAL_STORE,

  setSelected: selected => set({ selected }),
}))
